import React, { useRef } from 'react';
import styled from 'styled-components';
import { FaUpload, FaTimes } from 'react-icons/fa';

const Wrapper = styled.div`
  margin-bottom: 1rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.4rem;
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.nearBlack};
`;

const UploadArea = styled.div`
  border: 2px dashed ${({ theme }) => theme.colors.borderStrong};
  border-radius: ${({ theme }) => theme.radii.md};
  padding: 1.75rem;
  text-align: center;
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.base};
  background: ${({ theme }) => theme.colors.offWhite};

  &:hover {
    border-color: ${({ theme }) => theme.colors.gold};
    background: ${({ theme }) => theme.colors.goldSoft};
  }

  svg {
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.goldDark};
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.85rem;
    color: ${({ theme }) => theme.colors.textMuted};
    margin: 0;
  }
`;

const Preview = styled.div`
  position: relative;
  display: inline-block;
  margin-top: 0.25rem;

  img {
    max-width: 220px;
    max-height: 160px;
    border-radius: ${({ theme }) => theme.radii.sm};
    object-fit: cover;
    border: 1px solid ${({ theme }) => theme.colors.border};
  }
`;

const RemoveBtn = styled.button`
  position: absolute;
  top: -10px;
  right: -10px;
  background: ${({ theme }) => theme.colors.nearBlack};
  color: ${({ theme }) => theme.colors.gold};
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  box-shadow: ${({ theme }) => theme.shadows.card};
`;

const ImageUploader = ({ label, value, onChange, onRemove }) => {
  const inputRef = useRef();

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => onChange(reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <Wrapper>
      {label && <Label>{label}</Label>}
      {value ? (
        <Preview>
          <img src={value} alt="Preview" />
          <RemoveBtn onClick={onRemove} type="button" aria-label="Remove image">
            <FaTimes />
          </RemoveBtn>
        </Preview>
      ) : (
        <UploadArea onClick={() => inputRef.current.click()}>
          <FaUpload />
          <p>Click to upload image</p>
        </UploadArea>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleFile}
      />
    </Wrapper>
  );
};

export default ImageUploader;
